import withDraft from '@/utils/draftHelper';
import actions from '../constants';

const showAbout = withDraft((draft, { show }) => { draft.about = show; });

export default {
  [actions.SHOW_ABOUT]: showAbout,
};
